import React from 'react';
import { HelpCircle, LogOut, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { User } from '@supabase/supabase-js';
import { Logo } from '../ui/Logo';
import { useTutorial } from '../tutorial/TutorialProvider';

interface Props {
  user: User;
  onSignOut: () => void;
}

export function AppHeader({ user, onSignOut }: Props) {
  const { start } = useTutorial();
  return (
    <header className="bg-green-700 text-white sticky top-0 z-50 border-b border-white/10">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-3.5 flex items-center justify-between gap-3">
        <Logo variant="on-green" size="md" markSize={26} />
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={start}
            aria-label="Ver tutorial"
            title="Ver tutorial"
            className="inline-flex items-center justify-center w-8 h-8 rounded-md border-[1.5px] border-white/40 text-white transition-colors hover:bg-white/10 btn-focus"
          >
            <HelpCircle size={15} strokeWidth={2.25} />
          </button>
          <span
            className="hidden sm:block text-caption font-display font-medium text-white/75 tracking-[0.04em] max-w-[220px] truncate"
            title={user.email ?? ''}
          >
            {user.email}
          </span>
          <Link
            to="/configuracoes"
            aria-label="Configurações"
            title="Configurações"
            className="inline-flex items-center justify-center w-8 h-8 rounded-md border-[1.5px] border-white/40 text-white transition-colors hover:bg-white/10 btn-focus"
          >
            <Settings size={15} strokeWidth={2.25} />
          </Link>
          <button
            type="button"
            onClick={onSignOut}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border-[1.5px] border-white/40 text-white text-[13px] font-semibold font-body transition-colors hover:bg-white/10 btn-focus"
          >
            <LogOut size={14} strokeWidth={2.25} />
            <span className="hidden sm:inline">Sair</span>
          </button>
        </div>
      </div>
    </header>
  );
}
